import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getFroder = (id) => {
  return axiosClient
    .get(`api/admin/stats/gamer-frod/${id}`)
    .then((r) => r.data);
};
